import { render, staticRenderFns } from "./btn-relief.vue?vue&type=template&id=d69d97ae&"
import script from "./btn-relief.vue?vue&type=script&lang=js&"
export * from "./btn-relief.vue?vue&type=script&lang=js&"
import style0 from "./btn-relief.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports